import { DeliveryNoteFormValues } from "../types/deliveryNote.interfaces"

export const createDefaultLineItem = (): Omit<Partial<DeliveryNoteFormValues["lineItems"][number]>, "_id"> => ({
    quantity: 1,
    name: "",
    unitOfMeasure: "",
    materialCode: "",
})
